import React, { useRef } from 'react';
import DocumentAnalysisContext from '../../../contexts/DocumentAnalysisContext';
import StatusContext from '../../../contexts/StatusContext';
import AuthContext from '../../../contexts/AuthContext';
import {CustomTooltip} from  '../customtooltip/CustomTooltip'
import { AttachFile } from './AttachFile';


/*
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
*/

//pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const FileUploader = () => {

  const fileInputRef = useRef(null);

  let {
   
    setStatus,
    addFile,
    attachedFiles,

  } = React.useContext(DocumentAnalysisContext);

  let {
    changeLanguage,
    setShowLoginDialog,
  } = React.useContext(StatusContext);

  let {
    checkCurrentUser,
    currentUser,
  } = React.useContext(AuthContext);

  
  const handleFileChange = (event) => {

    
    let file = event.target.files[0]
    let filename = file.name

    if (file)
    {

      // Resetting the input value to allow re-selection of the same file
      event.target.value = null; // Clear the file input

      //Calculate attached files total size
      let totalSize = 0;
      attachedFiles.map((file, index) => ( 
        totalSize +=  file.size
      ))

      if (attachedFiles.length === 3)
      {
          window.alert(changeLanguage('documentanalysis', "filesmaxnumber"))
          return
      }
      if ( (totalSize + file.size) > 20000000) //20MB

        {
          window.alert(changeLanguage('documentanalysis', "filesizeoverlimit"))
          return
        }

      if (attachedFiles.find(file => file.name === filename))
        {
          window.alert(changeLanguage('documentanalysis', "fileexists"))

          return
        }
        
      
        if ( file.type && file.type.includes('text'))
        {
           handleFileUpload(file)
        }
        else if ( file.type && file.type.includes('pdf'))
        {
            handleFileUpload(file)
        }
        else if ( file.name.includes('docx'))
        {
            handleFileUpload(file)
        }
        /*
        else if ( file.type && file.type.includes('csv'))
        {
            handleFileUpload(file)
        }
        */
        else 
        {
            window.alert(changeLanguage('documentanalysis', "filenotsupported"))
        }
    
    }
  
  };

  const handleButtonClick = () => {
    console.log("handleButtonClisk")

    setStatus('')

    //check if user is logged in
     if (checkCurrentUser() === false) {
      setShowLoginDialog(true)
      return;
    }

    /*
    if (file_1.name && file_2.name && file_3.name)
    {
        window.alert(changeLanguage('status', "attachmaxthreefiles"))
        return
    }
      */
    // Trigger the file input click
    fileInputRef.current.click();
  };

  const handleFileUpload = async (file) => {
  
    const formData = new FormData();
    formData.append("file", file);
    formData.append("user", JSON.stringify(currentUser));
    formData.append("file_name", file.name);
    if (file.name.includes('.txt'))
      formData.append("file_type", 'txt')
    else  if (file.name.includes('.pdf'))
      formData.append("file_type", 'pdf')
    else  if (file.name.includes('.docx'))
      formData.append("file_type", 'docx')
    /*
     else  if (file.name.includes('.csv'))
      formData.append("file_type", 'csv')
    */
     else
      formData.append("file_type", file.type);
    formData.append("file_size", file.size);

    addFile( file.name, file.type, file.size, formData )
    
};

  return (
    <div >
  
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }} // Hide the input
        onChange={handleFileChange}
      />
   
      <CustomTooltip title={changeLanguage('status', 'attachfile')}>
        <span>
          <AttachFile onClick={handleButtonClick}/>
        </span>
      </CustomTooltip>

    </div>
  );
};


export default FileUploader;